import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import UserCard from '@comp/parts/UserCard.vue';
import SelectInput from '@comp/forms/inputs/SelectInput.vue';
import Icon from '@comp/Icon.vue';
import { VProgressCircular } from 'vuetify/lib';
import ArrowRightIcon from '!!url-loader?!@static/icons/s-arrow-right.svg';
import ArrowLeftIcon from '!!url-loader?!@static/icons/s-arrow-left.svg';
import { profileClient } from '@api/profile';
import { mapActions, mapState } from 'vuex';
export default {
  name: 'UserFollowers',
  components: {
    UserCard: UserCard,
    SelectInput: SelectInput,
    Icon: Icon,
    VProgressCircular: VProgressCircular
  },
  props: {
    stateType: {
      /** @param {'following' | 'followers'} **/
      type: String,
      default: null,
      validator: function validator(v) {
        return ['following', 'followers'].indexOf(v) !== -1;
      }
    },
    userName: {
      type: String,
      required: true
    },
    fullName: String,
    followingStatus: {
      type: String,
      required: true,
      validator: function validator(v) {
        return ['notFollowing', 'following', 'you'].indexOf(v) !== -1;
      }
    }
  },
  data: function data() {
    return {
      sortFollowers: 'popular',
      sortFollowing: 'popular',
      sortList: [{
        value: 'popular',
        title: 'Show popular'
      }, {
        value: 'upcoming',
        title: 'Show upcoming'
      }, {
        value: 'new',
        title: 'Show new'
      }],
      allLoad: true,
      // users
      allMutual: false,
      mutualUsers: [],
      mutualTotal: 0,
      followersUsers: [],
      followersTotal: 0,
      followersPage: 1,
      followersLoad: false,
      followersHaveNextPage: false,
      followingUsers: [],
      followingTotal: 0,
      followingPage: 1,
      followingLoad: false,
      followingHaveNextPage: false,
      ArrowRightIcon: ArrowRightIcon,
      ArrowLeftIcon: ArrowLeftIcon
    };
  },
  watch: {
    stateType: function stateType() {
      this.fetchUsers();
    },
    sortFollowers: function sortFollowers() {
      this.followersPage = 1;
      this.followersUsers = [];
      this.fetchFollowers();
    },
    sortFollowing: function sortFollowing() {
      this.followingPage = 1;
      this.followingUsers = [];
      this.fetchFollowing();
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState('userFollowing', {
    usersFollowingState: function usersFollowingState(state) {
      return state.byUserName;
    }
  })), {}, {
    filteredMutualUsers: function filteredMutualUsers() {
      if (this.allMutual) {
        return this.mutualUsers;
      }

      return this.mutualUsers.slice(0, 8);
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapActions('userFollowing', ['follow', 'unfollow'])), {}, {
    getFollowingStatus: function getFollowingStatus(_ref) {
      var userName = _ref.userName,
          followingStatus = _ref.followingStatus;
      return (this.usersFollowingState[userName] || {}).status || followingStatus;
    },
    isFollowLoading: function isFollowLoading(_ref2) {
      var userName = _ref2.userName;
      return !!(this.usersFollowingState[userName] || {}).loading;
    },
    allMutualToggle: function allMutualToggle() {
      this.allMutual = !this.allMutual;
    },
    loadMore: function loadMore() {
      var key = this.stateType === 'followers' ? 'followersUsers' : 'followingUsers';

      switch (key) {
        case 'followingUsers':
          {
            if (!this.followingLoad && this.followingHaveNextPage) {
              this.followingPage += 1;
              this.fetchFollowing();
            }
          }
          break;

        case 'followersUsers':
          {
            if (!this.followersLoad && this.followersHaveNextPage) {
              this.followersPage += 1;
              this.fetchFollowers();
            }
          }
          break;
      }
    },
    fetchUsers: function fetchUsers() {
      var _this = this;

      this.allLoad = true;
      this.followersPage = 1;
      this.followingPage = 1;
      this.mutualUsers = [];
      this.followersUsers = [];
      this.followingUsers = [];
      var promises = [];

      if (this.stateType === 'following') {
        promises = [this.fetchFollowing()];
      } else if (this.stateType === 'followers') {
        if (this.followingStatus !== 'you') {
          promises.push(this.fetchMutual());
        }

        promises.push(this.fetchFollowers());
      }

      Promise.all(promises).then(function () {
        _this.allLoad = false;
      }).catch(function (error) {
        _this.allLoad = false;
      });
    },
    fetchMutual: function fetchMutual() {
      var _this2 = this;

      return profileClient.mutual(this.userName).then(function (resp) {
        _this2.mutualTotal = resp.totalCount;
        _this2.mutualUsers = resp.users;
      }).catch(function (error) {});
    },
    fetchFollowers: function fetchFollowers() {
      var _this3 = this;

      this.followersLoad = true;
      return profileClient.followers(this.userName, this.sortFollowers, this.followersPage, 16).then(function (resp) {
        _this3.followersLoad = false;
        _this3.followersTotal = resp.totalCount;
        _this3.followersUsers = [].concat(_toConsumableArray(_this3.followersUsers), _toConsumableArray(resp.users));
        _this3.followersHaveNextPage = resp.hasNextPage;
      }).catch(function (error) {
        _this3.followersLoad = false;
      });
    },
    fetchFollowing: function fetchFollowing() {
      var _this4 = this;

      this.followingLoad = true;
      return profileClient.following(this.userName, this.sortFollowing, this.followingPage, 16).then(function (resp) {
        _this4.followingLoad = false;
        _this4.followingTotal = resp.totalCount;
        _this4.followingUsers = [].concat(_toConsumableArray(_this4.followingUsers), _toConsumableArray(resp.users));
        _this4.followingHaveNextPage = resp.hasNextPage;
      }).catch(function (error) {
        _this4.followingLoad = false;
      });
    }
  }),
  created: function created() {
    this.observer = new IntersectionObserver(this.loadMore, {
      rootMargin: '0px 0px 200px 0px',
      threshold: 0
    });
  },
  mounted: function mounted() {
    this.fetchUsers();
    this.observer.observe(this.$refs.endOfScroll);
  },
  beforeDestroy: function beforeDestroy() {
    this.observer.unobserve(this.$refs.endOfScroll);
  }
};